/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSurveyInput
 */
export interface CreateSurveyInput {
    /**
     * 
     * @type {string}
     * @memberof CreateSurveyInput
     */
    projectUUID: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateSurveyInput
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateSurveyInput
     */
    description: string;
}

/**
 * Check if a given object implements the CreateSurveyInput interface.
 */
export function instanceOfCreateSurveyInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectUUID" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function CreateSurveyInputFromJSON(json: any): CreateSurveyInput {
    return CreateSurveyInputFromJSONTyped(json, false);
}

export function CreateSurveyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSurveyInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectUUID': json['projectUUID'],
        'date': (new Date(json['date'])),
        'description': json['description'],
    };
}

export function CreateSurveyInputToJSON(value?: CreateSurveyInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectUUID': value.projectUUID,
        'date': (value.date.toISOString()),
        'description': value.description,
    };
}

